import React, { Component } from 'react';

import { Button, Container } from 'reactstrap';
import CreatePlcSafetyTriggerForm from '../../components/Forms/CreatePlcSafetyTriggerForm';

class NewPlcSafetyTrigger extends Component {
  goBack(event) {
    event.preventDefault();
    this.props.history.push('/plcSafetyTriggers');
  }

  render() {
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <CreatePlcSafetyTriggerForm />
        </Container>
      </div>
    );
  }
}

export default NewPlcSafetyTrigger;
